import './index.scss'

import { Link } from '@tanstack/react-router'
import { useAtom } from 'jotai'

import NotificationBadge from '@/components/notificationBadge'
import { Text } from '@/components/ui/typography'
import { isServerRespondingAtom } from '@/store/gigiChat/ChatAtom'

const NavigationLink = ({
    text,
    link,
    totalNotifications,
    onClick,
}: {
    text: string
    //unfortunatelly because of tanstack/router bug we should use any , if you find a better solution please do the neccesary updates
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    link?: any
    totalNotifications?: number
    onClick?: () => void
}) => {
    const [isServerResponding] = useAtom(isServerRespondingAtom)
    return (
        <Link
            to={link}
            className="navigationLink"
            activeProps={{
                className: 'active',
            }}
            activeOptions={{ exact: false }}
            style={{
                paddingTop: '24px',
                paddingBottom: '24px',
                paddingInline: '20px',
                textTransform: 'uppercase',
                letterSpacing: '1.5px',
            }}
            onClick={() => {
                onClick && onClick()
            }}
            disabled={isServerResponding}
        >
            <Text as="b" fontSize={12}>
                {text}
                {link === '/tasks-approvals' && <NotificationBadge total={totalNotifications ?? 0} />}
            </Text>
        </Link>
    )
}

export default NavigationLink
